import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "ui/components/dialog";
import ButtonWithLoading from "@/components/button-with-loading";

export default function CreateRepoDialog({
    open,
    onOpenChange,
    onConfirm,
    isLoading,
    project,
}) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Create Channel?</DialogTitle>
                    <DialogDescription>
                        By proceeding, a new Discord channel named "{project}" 
                         will be created for this project.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <ButtonWithLoading
                        onClick={onConfirm}
                        isLoading={isLoading}
                        disabled={isLoading}
                        variant="default"
                    >
                        Yes, Create
                    </ButtonWithLoading>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
